const swiper5 = new Swiper(".parent-collection-slider", {
  slidesPerView: 3,
  centeredSlides: true,
  spaceBetween: 40,
  freeMode: true,
  loop: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 5000,
  freeModeMomentum: false,

  slidesPerGroup: 1,
  breakpoints: {
    320: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
});

const swiper2 = new Swiper(".swiper-two-cols", {
  centeredSlides: true,
  effect: "fade",
  loop: true,
  observer: true,      
  observeParents: true, 
  autoplay: {
    delay: 1500,
    disableOnInteraction: false,
    pauseOnMouseEnter: false, 
  },
});

const swiper3 = new Swiper(".totem-slider-1 .swiper", {
  slidesPerView: "auto",
  spaceBetween: 40,
  effect: "slide",
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
});
const swiper4 = new Swiper(".sample-slider", {
  loop: false,
  slidesPerView: 2,
  centeredSlides: true,
  on: {
    resize: function enableOnlyMobile(swiper) {
      if (750 < window.innerWidth) {
        swiper4.disable();
      } else {
        swiper4.enable();
      }
    },
  },
});

const width = window.innerWidth;

const heroSlider = document.querySelector(".swiper-intro-desktop");

const main = document.querySelector(" main.index-main");

if (heroSlider) {
  heroSlider.style.display = "block";
  main.style.zIndex = 12;
}

const swiper = new Swiper(".swiper-intro-desktop", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  effect: 'slide',
  direction: "horizontal",
  speed: 2000,
  allowTouchMove: true,
  navigation: false,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  on: {
    reachEnd: function () {
      swiper.autoplay.stop();
    },
    slideChange(swiper) {
      const current = swiper.realIndex;
      if (current !== 0) {
        swiper.params.autoplay.delay = 1000;
      }
    }
  },
});

swiper.on("slideChange", () => {
  const currentSlide = swiper.realIndex;

  if (currentSlide === 1) {
    const sectionHeader = document.querySelector(".section-header");
    const introContent = document.querySelector(".intro-slider__content");
    sectionHeader.style.display = "block";
sectionHeader.zIndex = 14;
    main.style.zIndex = 3;
     setTimeout(() => {
introContent.classList.add('visible-slider__content');
    }, 800);
  }
});


const heroSliderMob = document.querySelector(".swiper-intro-mobile");

if (heroSliderMob) {
  heroSliderMob.style.display = "block";
  main.style.zIndex = 12;
}

const swiper8 = new Swiper(".swiper-intro-mobile", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  effect: "slide",
  direction: "horizontal",
  speed: 1000,
  allowTouchMove: true,
  navigation: false,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  on: {
    reachEnd: function () {
      swiper8.autoplay.stop();
    },

  },
});

swiper8.on("slideChange", () => {

  const currentSlideMob = swiper8.realIndex;

  if (currentSlideMob === 1) {
    const sectionHeaderMob = document.querySelector(".section-header");
    const introContent = document.querySelector(".swiper-intro-mobile .intro-slider__content");
    sectionHeaderMob.style.display = "block";
    sectionHeaderMob.zIndex = 14;
    main.style.zIndex = 3;
     setTimeout(() => {
introContent.classList.add('visible-slider__content');
    }, 800);
  }
});

const heroSliderTablet = document.querySelector(".swiper-intro-tablet");

if (heroSliderTablet) {
  heroSliderTablet.style.display = "block";
  main.style.zIndex = 12;
}

const swiper9 = new Swiper(".swiper-intro-tablet", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  effect: "slide",
  direction: "horizontal",
  speed: 1000,
  allowTouchMove: true,
  navigation: false,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  on: {
    reachEnd: function () {
      swiper9.autoplay.stop();
    },

  },
});

swiper9.on("slideChange", () => {

  const currentSlideTablet = swiper9.realIndex;

  if (currentSlideTablet === 1) {
    const sectionHeaderTablet = document.querySelector(".section-header");
    const introContent = document.querySelector(".swiper-intro-tablet .intro-slider__content");
    sectionHeaderTablet.style.display = "block";
    main.style.zIndex = 3;
     setTimeout(() => {
introContent.classList.add('visible-slider__content');
    }, 800);
  }
});

 
 



if (width < 1033) {
  const swiper6 = new Swiper(".text-swiper-container", {
    slidesPerView: "auto",
    spaceBetween: 40,
    grabCursor: true,
    freeMode: true,
        watchOverflow: true,
  observer: true,
  observeParents: true,
    })
}

const swiper7 = new Swiper(".video-swiper", {
  effect: "fade",
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  loop: true,
});

const swiper10 = new Swiper(".related-products-new .swiper", {
  slidesPerView: "auto", 
  spaceBetween: 0, 
  // freeMode: true, 
  // cssMode: true 
});

if (width < 768) {
  const swiper11 = new Swiper(".totem-icons-swiper-container", {
    slidesPerView: 5,
    spaceBetween: 20,
    grabCursor: true,
    freeMode: true,
   
    
     
  });
}
   
